import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-catalyst-core/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Seo = makeShortcode("Seo");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Seo title="Abolition Plaza" mdxType="Seo" />
    <h1 {...{
      "id": "abolition-plaza"
    }}>{`abolition plaza`}</h1>
    <p>{`Chances are you are now standing in `}<strong parentName="p">{`Abolition Plaza`}</strong>{` – a multi-use, solar-powered, wifi enabled outdoor meeting area and community garden. `}</p>
    <p>{`Located behind the Little House of Lombard Central Presbyterian Church, former station on the underground railroad and current home to `}<a parentName="p" {...{
        "href": "https://www.facebook.com/CADBIphilly",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`the Coalition to Abolish Death by Parole`}</a>{`
and `}<a parentName="p" {...{
        "href": "https://hrcoalition.org",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`Human Rights Coalition`}</a>{` offices.`}</p>
    <p>{`To create this space Holobiont Lab along with our symbiotic comrades from CADBI and HRC pulled up weeds, leveled the ground and built this space in the spirit of a barnraising. We used permeable pavers to create a sizeable central area including a seating area shaded by solar panels to generate energy for outdoor power/plug-in stations and an irrigation system for the nearby garden beds.`}</p>
    <p>{`The garden beds currently being tended by CADBI members are being serviced by a rain collection system with automated irrigation. One set of barrels will be connected into the downspout on the back wall of the office building, elevated with tubing attached and extending to the garden beds. A second set of barrels is situated between two of the garden beds along the chain link fencing near the middle of the lot itself. Irrigation tubing connects the two sets barrels and gravity feeds the second set. An irrigation controller, built from open source hardware and software distributes water periodically to the beds.`}</p>
    <p>{`In the central open area, will be the outdoor meeting and socializing space with seating and a table, covered by a solar pergola. The solar panels charge batteries and power the irrigation, as well as electronics and/or lighting (laptops, cell-phone charging, etc.). They will also provide significant shade for people utilizing the outdoor space.`}</p>
    <p>{`Also being powered by the solar shade is this wireless access point you are connected to. The web page you are reading is located here at Abolition Plaza.`}</p>
    <p>{`The name Abolition Plaza, draws upon both the abolitionist past and heritage of the space/church and the current movement to end mass incarceration. It will allow CADBI and HRC members to safely and comfortably meet outside in person to further their movement organizing (which is especially important in these moments as the Covid pandemic is still being brought under control and will continue to be an asset/resource far beyond then). And, of course, it will be generally available to everyone who makes use of the space.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      